import React, { useState, useEffect, useCallback, useRef } from "react";
import useStyles from "./style";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Slide,
  DialogActions,
  Typography,
  Button,
  IconButton,
  Divider,
  Grid,
  MenuItem,
  TextField,
  Autocomplete,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import _ from "lodash";

import { showLoader, hideLoader } from "Redux/Loader/actions";
import { showSnackbar } from "Redux/SnackBar/actions";
import { useDispatch } from "react-redux";

// Services
import driverApi from "Services/Driver";

// Constants
import { CUSTOM_CONSTANTS } from "Constants";
import { apiUrl } from "../../../../../../Constants";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const ViewFiles = (props) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { openDialog, handleClose, driverId, documentId, documentData } = props;

  const [filePath, setFilePath] = useState();

  useEffect(() => {
    setFilePath(`${apiUrl}${documentData?.file}`);
  }, [documentData]);

  const handleUpdateDocumentStatus = () => {
    dispatch(showLoader("Loading please wait..."));

    let validation = true;

    if (driverId === "" || driverId === undefined) {
      validation = false;
      dispatch(hideLoader());
    }

    let data = {
      document_type_id: documentData?.documentId,
      is_initial_document: true,
      status: "APPROVED",
      driver_id:driverId
    };

    const onSuccess = (res) => {
      dispatch(hideLoader());
      if (res?.data?.status === true) {
        dispatch(
          showSnackbar({
            message: "Document status updated successfully",
            autoHideDuration: 3000,
            anchorOrigin: {
              vertical: "top",
              horizontal: "right",
            },
            variant: "success",
          })
        );
        handleClose();
      }
    };
    const onFailure = (err) => {
      dispatch(hideLoader());
      showSnackbar({
        message: "Failed to update document status",
        autoHideDuration: 3000,
        anchorOrigin: {
          vertical: "top",
          horizontal: "right",
        },
        variant: "error",
      });
    };

    if (validation) {
      driverApi.updateDriverDocument({ ...data }).then(onSuccess, onFailure);
    }
  };

  // Delete Document

  const handleDeleteDocument = (row) => {
    var result = window.confirm("Do you want to Delete?");

   if (result) {

   //console.log('result--->',result);
   
   dispatch(showLoader("Loading please wait..."));

   let validation = true;

   if (driverId === "" || driverId === undefined) {
     validation = false;
     dispatch(hideLoader());
   }
   
   let data = {
    document_type_id:documentId,
    driver_id:driverId,
  }

   const onSuccess = (res) => {
     dispatch(hideLoader());
     if (res?.data?.status === true) {
       dispatch(
         showSnackbar({
           message: "Document deleted successfully",
           autoHideDuration: 3000,
           anchorOrigin: {
             vertical: "top",
             horizontal: "right",
           },
           variant: "success",
         })
       );
     }
     handleClose();
   };

   const onFailure = (err) => {
     dispatch(hideLoader());
     showSnackbar({
       message: "Failed to delete the document",
       autoHideDuration: 3000,
       anchorOrigin: {
         vertical: "top",
         horizontal: "right",
       },
       variant: "error",
     });
   };
    
   //console.log('data-->',data);

   if (validation) {
    driverApi.deleteDriverDocument({ ...data }).then(onSuccess, onFailure);
   }
    }

  };

  return (
    <>
      <Dialog
        open={openDialog}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleClose}
        maxWidth={"md"}
        aria-describedby="dialog-box"
        className={classes.root}
      >
        <DialogTitle>
          <section className={classes.dialogTitleContainer}>
            <Typography variant="body1" className={classes.title}>
              View a file 
            </Typography>
            <IconButton aria-label="close" onClick={handleClose}>
              <CloseIcon className={classes.closeIcon} />
            </IconButton>
          </section>
        </DialogTitle>
        <DialogContent>
          <div className={classes.uploadAreaWrapper}>
            {filePath && (
              <div className={classes.previewDocumentWrapper}>
                <Typography>Preview Document</Typography>
                <iframe
                  title="Document Viewer"
                  src={filePath}
                  className={classes.documentViewerWrapper}
                ></iframe>
              </div>
            )}
          </div>
        </DialogContent>
        <Divider />
        <DialogActions>
          <section className={classes.dialogActions}>
            <section className={classes.closeBtn}>
              <Button onClick={handleClose} style={{ marginRight: "10px" }}>
                Close
              </Button>
            </section>
            <section className={classes.closeBtn}>
              <Button
                onClick={handleDeleteDocument}
                style={{ marginRight: "10px" }}
              >
                Delete
              </Button>
            </section>
            {documentData?.status != "APPROVED" && (
            <section className={classes.approveBtn}>
              <Button onClick={handleUpdateDocumentStatus}>Approve</Button>
            </section>
            )}
          </section>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default ViewFiles;
